export const navItems = [
    { to: '/', label: 'Coffee house', end: true },
    { to: '/our_coffee', label: 'Our coffee', end: true },
    { to: '/for_your_pleasure', label: 'For your pleasure', end: true }
];
